import React, { memo } from 'react';
import { PropTypes } from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const FileNameModal = memo(props => {
  const {
    showFileNameModal,
    setShowFileNameModal,
    files,
    fileNames,
    handleFileNameModifyChecked,
    handleFileNameModifyInputChanged,
    submitAction,
  } = props;

  return showFileNameModal ? (
    <div
      className="h-screen w-screen  backdrop-blur-sm  z-50 flex justify-center items-center transition-all duration-1000 ease-in-out"
      style={{ position: 'fixed', top: '0', left: '0', zIndex: 1001 }}
    >
      <div className="w-3/6  bg-white rounded-md z-40 shadow-2xl opacity-100 duration-1000 ease-in-out">
        <div className="flex justify-end">
          <button
            type="button"
            className="cursor-pointer transition-transform duration-700 hover:rotate-90 hover:text-primary text-dark-night"
            onClick={() => setShowFileNameModal(false)}
          >
            <i className="material-icons text-[24px] m-4 !text-inherit">close</i>
          </button>
        </div>

        <h2 className=" mt-4 font-bold text-lg text-center">Give Your File A Name</h2>
        <p className="text-sm mt-1 text-[#9a6c4c] supported-files text-center">
          File Name must be unique
        </p>

        {files.map((el, i) => {
          return (
            <div className="flex flex-col justify-center items-center mt-4 " key={uuidv4()}>
              <div className="flex space-x-2 items-center mt-4">
                <input
                  type="checkbox"
                  data-test="edd-file-name-checker"
                  onChange={e => handleFileNameModifyChecked(e, i)}
                  onClick={e => {
                    e.stopPropagation();
                  }}
                  className="w-8 h-8 rounded-lg orange-edd-checkbox  form-checkbox rounded-full block"
                />
                <p className="text-sm">Check to use original file name</p>
              </div>

              <div>
                <input
                  data-test="edd-file-name-input"
                  className="rounded-lg mt-4  border outline-none border-slate-200  w-48 h-12 bg-white shadow-md p-2 
                         focus:border-orange-500 focus:ring-0 focus:outline-none"
                  placeholder="enter file name"
                  value={fileNames[i]}
                  onChange={e => handleFileNameModifyInputChanged(e, i)}
                />
                <p className="text-sm mt-1 text-red-500 supported-files text-start ml-0 hidden p-0">
                  File Name already taken
                </p>
              </div>
            </div>
          );
        })}

        <div className="flex justify-center pb-4">
          <button
            data-test="edd-name-submit"
            type="button"
            className="bg-orange-500 hover:scale-x-105 hover:scale-y-105 transition duration-500 z-30 shadow-md  w-32 h-12 rounded-lg text-white mt-16 text-sm font-bold px-2 hover:animate-pulseOpacity"
            onClick={() => submitAction()}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  ) : null;
});

export default FileNameModal;

FileNameModal.propTypes = {
  showFileNameModal: PropTypes.bool,
  setShowFileNameModal: PropTypes.func,
  files: PropTypes.array,
  fileNames: PropTypes.array,
  handleFileNameModifyChecked: PropTypes.func,
  handleFileNameModifyInputChanged: PropTypes.func,
  submitAction: PropTypes.func,
};
